export const BASE_API_URL = process.env.REACT_APP_SIFUSE_API_URL
export const WEB_SOCKET_URL = process.env.REACT_APP_WEB_SOCKET_URL
export const FILES_URL = process.env.REACT_APP_FILES_URL
